import { render, staticRenderFns } from "./CareerBody.vue?vue&type=template&id=1876875b&scoped=true&"
import script from "./CareerBody.vue?vue&type=script&lang=js&"
export * from "./CareerBody.vue?vue&type=script&lang=js&"
import style0 from "./CareerBody.vue?vue&type=style&index=0&id=1876875b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1876875b",
  null
  
)

export default component.exports